import { tipsWidget } from 'config'
import React, { Component } from 'react'
import styled from 'styled-components'
import { Grid } from 'react-flexbox-grid'
import { Input } from '@ubiwherenpm/adene-ui-components'
import Logic from './logic'
import { getCookie } from 'utils'

import MyTarifSectionV2 from 'components/MyTarifSectionV2'
import MyTarifMobileSectionV2 from 'components/MyTarifMobileSectionV2'
import ResultsSectionV2 from 'components/ResultsSectionV2'
import ResultsSectionMobileV2 from 'components/ResultsSectionV2/mobile'
import FiltersSectionV2 from 'containers/FiltersSectionV2'
import FeedbackModalV2 from 'components/FeedbackModalV2'

import EditIcon from 'components/MyTarifSectionV2/images/ic-edit.component.svg'
import SearchIcon from 'components/Svg/search.svg'
import ArrowIcon from 'components/Svg/arrow.svg'
import OrderIcon from 'components/Svg/order.svg'
import NoResultsV2 from 'components/NoResultsV2'
import SimulationTimeouErrorV2 from 'components/SimulationTimeoutErrorV2'
import Loading from 'components/Loading'
import Simulating from 'components/Simulating'
import PaginationV2 from 'components/PaginationV2'
import Select from 'components/Select'
import ButtonGradientV2 from 'components/ButtonGradientV2'

import IcSuccess from './images/success.component.svg'

export const Orders = [
  { label: 'Ordernar por preço ascendente', value: 'asc' },
  { label: 'Ordernar por preço descendente', value: 'dec' },
]

export const SearchInputOptions = {
  type: 'text',
  placeholder: 'Nome do comercializador… ',
  icon: SearchIcon,
}

export const OrderSelectOptions = {
  placeholder: 'Ordernar..',
  items: Orders,
  icon: OrderIcon,
  arrowIcon: ArrowIcon,
}

@Logic
export default class Results extends Component {
  state = {
    showAll: false,
    width: 0,
    feedbackModal: false,
    dataModal: false,
  }

  componentWillMount() {
    if (tipsWidget) {
      tipsWidget.style.cssText = ''
    }

    if (this.state.width < 1000) {
      this.actions.resetEntities()
      this.actions.setSearchQuery('')
      this.actions.setEntitiesCount(0)
      this.actions.setEntitiesOffset(0)
    }
  }

  /**
   * Stuff to do on first mount
   */
  componentDidMount() {
    window.onpopstate = (e) => {
      e.preventDefault()
      this.props.router.push('/')
    }

    this.handleResize(true)
    window.addEventListener('resize', this.handleResize)
  }

  componentDidUpdate(oldProps) {
    const { simulatingPatch, simulating } = this.props
    const {
      simulatingPatch: oldSimulatingPatch,
      simulating: oldSimulating,
    } = oldProps

    if (
      !simulating &&
      !simulatingPatch &&
      (oldSimulatingPatch || oldSimulating)
    ) {
      const element = document.getElementById('anchor')

      window.scroll({
        top: element.getBoundingClientRect().top,
      })
    }

    // Remove existing event listener to prevent multiple attachments
    window.removeEventListener('message', this.handleMessage)

    // Add event listener with the bound method
    window.addEventListener('message', this.handleMessage)

    const URLQuery = window.location.search
    window.parent.postMessage({ type: 'setUrlParams', params: URLQuery }, '*')

    this.handleResize(false)
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    if (tipsWidget) {
      tipsWidget.style.cssText = ''
    }

    window.onpopstate = null
    window.removeEventListener('resize', this.handleResize)
  }

  // Define handleMessage as a class method
  handleMessage = (event) => {
    if (event.data.triggerFeedbackModal) {
      this.actions.setModalTriggerHeight(600)
      this.setState({ feedbackModal: true })
    }
  }

  toggleDataModal = () => {
    this.setState({
      dataModal: !this.state.dataModal,
    })
  }

  sendHeight = () => {
    const height = document.body.scrollHeight
    window.parent.postMessage({ type: 'setHeight', height }, '*')
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  handleResize = (updateState) => {
    updateState && this.updateWindowDimensions()
    this.sendHeight()
  }

  toggleFilters = () => {
    const { filtering } = this.props
    if (filtering) {
      this.actions.closeFiltering()
    } else {
      this.actions.openFiltering()
    }
  }

  renderCurrentTarfif = () => {
    const { simulation, router, values } = this.props

    const { changeSimulationData, resetFilters, setSearchQuery } = this.actions

    const hasSimulation = simulation && simulation.results
    const { simulationCode } = this.props.values

    return this.state.width >= 1000 ? (
      <MyTarifSectionV2
        dataModal={this.state.dataModal}
        toggleDataModal={this.toggleDataModal}
        hasSimulation={hasSimulation}
        router={router}
        simulationCode={simulationCode}
        changeSimulationData={changeSimulationData}
        simulationValues={values}
        setModalTriggerHeight={this.actions.setModalTriggerHeight}
        modalTriggerHeight={this.props.modalTriggerHeight}
        resetFilters={resetFilters}
        setSearchQuery={setSearchQuery}
        {...simulation.results}
      />
    ) : (
      <MyTarifMobileSectionV2
        dataModal={this.state.dataModal}
        toggleDataModal={this.toggleDataModal}
        hasSimulation={hasSimulation}
        router={router}
        simulationCode={simulationCode}
        changeSimulationData={changeSimulationData}
        simulationValues={values}
        setModalTriggerHeight={this.actions.setModalTriggerHeight}
        modalTriggerHeight={this.props.modalTriggerHeight}
        resetFilters={resetFilters}
        setSearchQuery={setSearchQuery}
        {...simulation.results}
      />
    )
  }

  renderFeedbackModal = () => {
    const { feedbackModal } = this.state
    const feedbackSubmitted = getCookie('feedbackSubmitted')

    return feedbackModal && !feedbackSubmitted ? (
      <FeedbackModalV2
        setModalTriggerHeight={this.actions.setModalTriggerHeight}
        modalTriggerHeight={this.props.modalTriggerHeight}
        width={this.state.width}
        onClose={() => this.setState({ feedbackModal: false })}
      />
    ) : null
  }

  renderResultSection = () => {
    const { simulation, sugestions, ordering } = this.props

    const { order } = this.actions
    const bestAnnualBilling =
      simulation && simulation.results && simulation.results.annualBilling

    return this.state.width >= 1000 ? (
      <ResultsSectionV2
        count={sugestions.count}
        ordering={ordering}
        order={order}
        results={sugestions.results}
        bestAnnualBilling={bestAnnualBilling}
        simulation={simulation}
        setModalTriggerHeight={this.actions.setModalTriggerHeight}
        modalTriggerHeight={this.props.modalTriggerHeight}
      />
    ) : (
      <ResultsSectionMobileV2
        ordering={ordering}
        order={order}
        count={sugestions.count}
        results={sugestions.results}
        bestAnnualBilling={bestAnnualBilling}
        simulation={simulation}
        changePage={this.actions.changePage}
        setModalTriggerHeight={this.actions.setModalTriggerHeight}
        modalTriggerHeight={this.props.modalTriggerHeight}
      />
    )
  }

  renderDesktopFilters = () => {
    return this.state.width >= 1000 ? (
      <FiltersWrapper>
        <FiltersSectionV2
          changePage={this.actions.changePage}
          simulation={this.props.simulation}
        />
      </FiltersWrapper>
    ) : null
  }

  render() {
    const {
      simulation,
      loadingSugested,
      sugestions,
      simulating,
      currentPage,
      simulatingPatch,
      finished,
      translations,
    } = this.props

    const { showAll } = this.state

    const { changePage, resetFilters, makeSimulation } = this.actions

    const simulationError =
      finished && finished.simulationError
        ? translations[
            'ERROR_' + (finished.simulationErrorCode + '').toUpperCase()
          ]
        : null

    const showResults =
      !loadingSugested && sugestions.results && sugestions.results.length
    const isLoading = loadingSugested
    const showNoResults =
      !loadingSugested && (!sugestions.results || !sugestions.results.length)
    const bestAnnualBilling =
      simulation && simulation.results && simulation.results.annualBilling
    const hasSimulation = simulation && simulation.results

    // this
    const isFirstResultNegative =
      showAll || currentPage > 1 || isLoading
        ? false // Showing all(ex clicked see more anchor)
        : sugestions && // Has simulation
          sugestions.results &&
          sugestions.results.length && // has results
          bestAnnualBilling - sugestions.results[0].annualBilling <= 0 // First result anual billing <= 0

    if (tipsWidget && !simulating) {
      tipsWidget.style.cssText = 'display:block!important'
    }

    if (simulating) {
      if (tipsWidget) {
        tipsWidget.style.cssText = ''
      }
      return <Simulating />
    }

    if (simulatingPatch) {
      if (tipsWidget) {
        tipsWidget.style.cssText = ''
      }
      return <Simulating />
    }

    let content
    if (isLoading) {
      content = <Loading />
    } else if (isFirstResultNegative) {
      //* First Result is Negative - Current tariff is the best already
      content = (
        <Best>
          <IcSuccess />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              alignSelf: 'stretch',
            }}>
            <Message>O seu Tarifário atual é o mais barato.</Message>
            <Description>
              O seu tarifário atual já oferece as melhores condições, por isso
              não encontramos opções mais vantajosas. Se pretender visualizar as
              opções, pode vê-las{' '}
              <b onClick={() => this.setState({ showAll: !showAll })}>aqui.</b>
            </Description>
          </div>
        </Best>
      )
    } else if (hasSimulation && showResults && !isFirstResultNegative) {
      //* Results exist and the first result is cheaper than the current tariff
      content = (
        <div>
          {this.renderResultSection()}
          <PaginationWrapper>
            <PaginationV2
              count={sugestions.count}
              pageChange={(params) => {
                setTimeout(() => {
                  const element = document.querySelector('div[data-results]')
                  if (element) {
                    window.parent.postMessage({ type: 'scrollToTop' }, '*')
                    window.scrollTo({
                      top: element.offsetTop,
                      behavior: 'smooth',
                    })
                  }
                }, 100)
                changePage(params)
              }}
              currentPage={currentPage}
            />
          </PaginationWrapper>
        </div>
      )
    } else if (
      (hasSimulation && showNoResults && !isFirstResultNegative) ||
      finished.simulationErrorCode === 'no_items'
    ) {
      //* Results don't exist
      content = (
        <NoResultsWrapper>
          <TitleRow>
            <h3>Resultados (0)</h3>
            <button onClick={resetFilters}>Limpar Filtros</button>
          </TitleRow>
          <NoResultsV2 title={true} text={true}>
            <NoResultsBtnWrapper>
              <ButtonGradientV2
                onClick={() => this.toggleDataModal()}
                style={{ width: '200px' }}
                icon={<EditIcon />}>
                Editar Dados
              </ButtonGradientV2>
            </NoResultsBtnWrapper>
          </NoResultsV2>
        </NoResultsWrapper>
      )
    } else if (
      !hasSimulation &&
      finished.simulationErrorCode !== 'timeout' &&
      finished.simulationErrorCode !== 'no_items'
    ) {
      //* Error occured
      content = (
        <NoResultsV2 title={false} text={false}>
          <NoSimTitle
            grey
            dangerouslySetInnerHTML={{ __html: simulationError }}
          />
        </NoResultsV2>
      )
    } else if (!hasSimulation && finished.simulationErrorCode === 'timeout') {
      //* Timeout (504) Error occured
      content = (
        <SimulationTimeouErrorV2 title={false} text={false}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <ButtonGradientV2
              onClick={() => makeSimulation()}
              style={{ width: '200px' }}>
              Tentar Novamente
            </ButtonGradientV2>
          </div>
        </SimulationTimeouErrorV2>
      )
    }

    return (
      <Wrapper>
        {this.renderCurrentTarfif()}
        <Background>
          <Content>
            {this.renderDesktopFilters()}
            <ResultsWrapper data-results>{content}</ResultsWrapper>
          </Content>
        </Background>
        {this.renderFeedbackModal()}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  width: 100%;
`

const Background = styled.div`
  width: 100%;
  background: #f9f9f9;
`

const Best = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

const Message = styled.span`
  overflow: hidden;
  color: #1d1e22;
  text-overflow: ellipsis;
  font-family: Nunito;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
  letter-spacing: 1px;
`

const Description = styled.p`
  overflow: hidden;
  color: #3e3e3e;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  margin: 0;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  > b {
    cursor: pointer;
    color: #1d1e22;
    font-weight: 700;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
`

const NoResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

const NoSimTitle = styled.div`
  color: #010101;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  margin: 0;
  padding-top: 16px;
`

const TitleRow = styled.div`
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 0px;

  h3 {
    flex: 1 0 0;
    color: #1d1e22;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 1px;
    margin: 0;
    text-transform: none;
    text-align: start;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;

    border: none;
    outline: none;
    background: transparent;

    cursor: pointer;

    color: #006736;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;

    &:hover {
      text-decoration: underline;
    }
  }
`

const Content = styled.div`
  display: flex;
  padding: 0px 20px 16px 20px;
  align-items: flex-start;
  gap: 32px;
  flex-shrink: 0;
  align-self: stretch;
  max-width: 1200px;
  margin-inline: auto;

  @media screen and (min-width: 1300px) {
    padding-inline: 0px;
  }
`

// const FeedbackBtnWrapper = styled.div`
//   overflow: hidden;
//   position: fixed;
//   width: 100%;
//   left: 0;
//   top: 90%;

//   > div {
//     max-width: 1200px;
//     margin-inline: auto;
//     display: flex;
//     justify-content: flex-end;
//     padding-inline: 20px;

//     @media screen and (min-width: 1300px) {
//       padding-inline: 0px;
//     }
//   }
// `

const FiltersWrapper = styled.div`
  min-width: 270px;
`

const ResultsWrapper = styled.div`
  flex: 1 0 0;
`

const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 11;
  position: relative;
`

const NoResultsBtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const Container = styled(Grid)`
  width: 1200px;
  margin: 0 auto;

  @media (max-width: 1280px) {
    width: 100%;
    box-sizing: border-box;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 40px;
  position: relative;
  z-index: 11;
  float: right;

  @media (max-width: 1280px) {
    width: 100%;
    box-sizing: border-box;
    margin-top: 70px;
  }
`

export const SearchInput = styled(Input)`
  width: 250px;

  @media (max-width: 1280px) {
    width: 100%;
    box-sizing: border-box;
  }
`

export const OrderSelect = styled(Select)`
  min-width: 280px;
  margin-left: 10px;
`



// WEBPACK FOOTER //
// ./src/containers/ResultsV2/index.js